import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'
import apiConfig from '@services/apiConfig'
import showToast from '@util/ToastUtil'
import {
  LOGIN,
  setLoggedIn,
  GET_PROFILE,
  setProfile,
  SAVE_PROFILE,
  PASSWORD_RECOVERY,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  GET_REPORT_DATA_BY_TOKEN,
  setReportDataByToken
} from '@actions/user'
import errorHandler from '@stores/errorHandler'
import AuthUtil from '@util/AuthUtil'
import { getDateStringFromFormattedDateStr } from '@util/timeUtil'
import { onlyNumbersMask } from '@util/stringUtil'

function* login({ data, callback }) {
  try {
    AuthUtil.clearAccessToken()
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/login`,
      data,
    })

    AuthUtil.newSession(response.headers.authorization)
    const user = { username: data.username }
    localStorage.setItem('user', JSON.stringify(user))
    yield put(setLoggedIn(true, data.username))
    callback && callback(true)
  } catch (error) {
    callback && callback(false)
    yield put(setLoggedIn(false))
    errorHandler(error)
  }
}

function* getProfile() {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/users`,
    })
    yield put(setProfile(response.data))
  } catch (error) {
    errorHandler(error)
  }
}

function* saveProfile({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'PUT',
      url: `${apiConfig.prefix}/users`,
      data: {
        ...data,
        cpf: onlyNumbersMask(data.cpf),
        phoneNumber: onlyNumbersMask(data.phoneNumber),
        birthdate: getDateStringFromFormattedDateStr(data.birthdate),
      },
    })
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

function* passwordRecovery({
  email, captcha, isResend, callback
}) {
  try {
    yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/users/reset-password`,
      data: {
        email,
        captcha,
        isResend,
      },
    })
    callback && callback()
  } catch (error) {
    const errorMessage = error.response && error.response.data ? error.response.data : 'Erro ao validar captcha'
    callback && callback({ message: errorMessage })
    errorHandler(error)
  }
}

function* resetPassword({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/users/recover-password`,
      data,
    })
    callback && callback(response.data)
  } catch (error) {
    callback && callback(error.response.data)
    errorHandler(error)
  }
}

function* changePassword({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/users/change-password`,
      data,
    })
    callback && callback(response.data)
    showToast('success', 'Senha alterada com sucesso')
  } catch (error) {
    callback && callback(error.response.data)
    errorHandler(error)
  }
}

function* getReportDataByToken({ token, id, collectionId }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/users/report-data/${id}/${collectionId}?token=${token}`,
    })
    yield put(setReportDataByToken(response.data))
  } catch (error) {
    errorHandler(error)
  }
}

export function* loginSaga() {
  yield takeLatest(LOGIN, login)
}

export function* getProfileSaga() {
  yield takeLatest(GET_PROFILE, getProfile)
}

export function* saveProfileSaga() {
  yield takeLatest(SAVE_PROFILE, saveProfile)
}

export function* passwordRecoverySaga() {
  yield takeLatest(PASSWORD_RECOVERY, passwordRecovery)
}

export function* resetPasswordSaga() {
  yield takeLatest(RESET_PASSWORD, resetPassword)
}

export function* changePasswordSaga() {
  yield takeLatest(CHANGE_PASSWORD, changePassword)
}

export function* getReportDataByTokenSaga() {
  yield takeLatest(GET_REPORT_DATA_BY_TOKEN, getReportDataByToken)
}
